import React, { type ReactNode } from 'react';

import { RelayEnvironmentProvider } from 'react-relay';
import { createMockEnvironment } from 'relay-test-utils';

import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';

export const ModalRelayWrapper = ({ children }: { children: ReactNode }): React.JSX.Element => {
	const env = createMockEnvironment();
	return (
		<RelayEnvironmentProvider environment={env}>
			<ModalContextProvider>{children}</ModalContextProvider>
		</RelayEnvironmentProvider>
	);
};

export const RelayWrapper = ({ children }: { children: ReactNode }): React.JSX.Element => {
	const env = createMockEnvironment();
	return <RelayEnvironmentProvider environment={env}>{children}</RelayEnvironmentProvider>;
};
